import { render, staticRenderFns } from "./TheVideoInfo.vue?vue&type=template&id=69aa4c18&scoped=true&lang=html"
import script from "./TheVideoInfo.vue?vue&type=script&lang=ts"
export * from "./TheVideoInfo.vue?vue&type=script&lang=ts"
import style0 from "./TheVideoInfo.vue?vue&type=style&index=0&id=69aa4c18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69aa4c18",
  null
  
)

export default component.exports